import moment from "moment";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setBailiffDialogPlay } from "store/bailiff/bailiff/dialog/bailiff_dialog.action";
import { bailiffDialogSecondSelector } from "store/bailiff/bailiff/dialog/bailiff_dialog.selector";
//
//component
//redux
//selector
//actions
const TriggerOver = ({ audio, start, end, setTrigger }) => {
  // -------------------------- VAR ----------------------------
  // -------------------------- STATE --------------------------
  // -------------------------- REDUX --------------------------
  const dispatch = useDispatch();
  const second = useSelector(bailiffDialogSecondSelector);
  // -------------------------- USE EFFECT ---------------------
  useEffect(() => {
    if (!audio) return;
    //nếu chưa tới start.
    if (second < start) {
      audio.pause();
      const id = `change-${moment()?.valueOf()}-${start}`;
      dispatch(setBailiffDialogPlay(false));
      setTrigger(id);
    }

    //nếu quá end.
    if (second > end) {
      audio.pause();
      const id = `change-${moment()?.valueOf()}-${end}`;
      dispatch(setBailiffDialogPlay(false));
      setTrigger(id);
    }
  }, [start, end, second, audio, dispatch, setTrigger]);
  // -------------------------- RETURN --------------------------
  return <></>;
};
export default TriggerOver;
